import { Box, Flex, Progress, Stack, Text } from "@chakra-ui/react";
import InfoCard from "src/pages/matrimony/components/InfoCard";

export type ConnectionsInfo = {
  totalConnections: number;
  recentlyActive: number;
  sentToday?: number;
  dailyLimit?: number;
};

type Props = {
  activeTab: "RECEIVED" | "SENT" | "CONNECTIONS";
  connectionsInfo?: ConnectionsInfo;
};

export default function ConnectionsInfoSidebar({ activeTab, connectionsInfo }: Props) {
  const sentToday = connectionsInfo?.sentToday ?? 0;
  const dailyLimit = connectionsInfo?.dailyLimit ?? 5;
  const pct = dailyLimit > 0 ? Math.min(100, Math.round((sentToday / dailyLimit) * 100)) : 0;

  const DailyInterestLimitCard = (
    <InfoCard title="Daily Interest Limit">
      <Stack spacing={3}>
        <Flex justify="space-between" align="center">
          <Text color="#6C757D">
            {sentToday} of {dailyLimit} requests sent today
          </Text>
          <Text fontWeight="700" color="#1F0812">
            {pct}%
          </Text>
        </Flex>
        <Progress
          value={pct}
          size="sm"
          borderRadius="999px"
          bg="#EFE7E1"
          sx={{
            "& > div": {
              background: "#4A2C2A",
            },
          }}
        />
        <Text fontSize="xs" color="#6C757D">
          Tip: Personalize your requests to improve response rates by 40%.
        </Text>
      </Stack>
    </InfoCard>
  );

  // Received tab: render only Daily Interest Limit
  if (activeTab === "RECEIVED") {
    return <Stack spacing={4}>{DailyInterestLimitCard}</Stack>;
  }

  // Sent tab sidebar (Daily Interest Limit + Upgrade to Premium)
  if (activeTab === "SENT") {
    return (
      <Stack spacing={4}>
        {DailyInterestLimitCard}
      </Stack>
    );
  }

  if (activeTab === "CONNECTIONS") {
    return (
      <Stack spacing={4}>
        <InfoCard title="Connection Insights">
          <Stack spacing={3}>
            <Flex justify="space-between">
              <Text color="#6C757D">Total Connections</Text>
              <Text fontWeight="700" color="#1F0812">
                {connectionsInfo?.totalConnections ?? 0}
              </Text>
            </Flex>
            <Flex justify="space-between">
              <Text color="#6C757D">Recently Active</Text>
              <Text fontWeight="700" color="#1F0812">
                {connectionsInfo?.recentlyActive ?? 0}
              </Text>
            </Flex>
            <Text fontSize="xs" color="#6C757D" pt={1}>
              Tip: Following up within 48 hours of connection increases the chance of a meeting by 3x.
            </Text>
          </Stack>
        </InfoCard>
      </Stack>
    );
  }

  return <Box />;
}
